
import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    useCallback,
  } from "react";
import { getDownloadUserAcc } from "./utils";

//Create the Context 
 const DownloadUsersContext = createContext();

 //Create a Provider component

 export const DownloadUserProvider = ({children}) => {
    const [downloadUserAcc, setDownloadUserAcc] = useState([])
    const loadDownloadUserAcc = useCallback(()=> {
        getDownloadUserAcc(setDownloadUserAcc)
    })
    useEffect(() => {
        loadDownloadUserAcc();
    },[])
    return (
        <DownloadUsersContext.Provider
         value={{
            downloadUserAcc,
            setDownloadUserAcc
         }}
        >
            {children}
        </DownloadUsersContext.Provider>
    )
 }

 // Custom hook to use the AnnouncementsContext
 export const useDownloadUsers = () => {
    const context = useContext(DownloadUsersContext);
    if (!context) {
        throw new Error(
          "useDownloadUsers must be used within an DownloadUserProvider"
        );
      }
      return context;
 }

